import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { connect } from 'react-redux';
import { getNCFileById, getNCFileByName } from '@reducers/manufacture';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { getProductionBatchByNCFile, operationsSearch } from '@reducers/search';
import { useNCFileDetails } from '@v2/pages/common/hooks/useNCFileDetails';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { NCFileSearchItem, OperationSearchItem } from '@interfaces/search';
import { ImagesDocumentsContent } from '@v2/pages/nc-file/details/modules/nc-file/components/ImagesDocumentsContent';
import { DOCUMENT_ENTITY_TYPE } from '@components/imageHandling/common';
import { View } from 'react-native';
import { DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';

interface NCFileDetailsJobsDocumentsProps {
  ncFileData: ReducerEntityWithLoadingState<NCFileSearchItem | null>;
  jobs: ReducerEntityWithLoadingState<OperationSearchItem[]>;
  jobId: number | null;
}

const NCFileDetailsJobsDocumentsComponent: FC<NCFileDetailsJobsDocumentsProps> = ({
  getNCFileById,
  getProductionBatchByNCFile,
  getTools,
  clearTools,
  updateHeaderConfig,
  operationsSearch,
  jobId,
  getNCFileByName,
}) => {
  const title = useTitle();

  useNCFileDetails({
    getNCFileById,
    getProductionBatchByNCFile,
    getTools,
    clearTools,
    updateHeaderConfig,
    operationsSearch,
    loadAllJobs: true,
    getNCFileByName,
  });

  return (
    <DetailsPageWrapper title={title.job}>
      {jobId && (
        <View style={DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES}>
          <ImagesDocumentsContent documentRetrieveId={jobId} documentRetrieveKey={DOCUMENT_ENTITY_TYPE.ProductionOperation} />
        </View>
      )}
    </DetailsPageWrapper>
  );
};

const NCFileDetailsJobsDocuments = connect(({ details: { jobId } }) => ({ jobId }), {
  getNCFileById,
  getProductionBatchByNCFile,
  getTools,
  clearTools,
  updateHeaderConfig,
  operationsSearch,
  getNCFileByName,
})(NCFileDetailsJobsDocumentsComponent);

export { NCFileDetailsJobsDocuments };
